<ui-release-alert *ngIf="(outdated$ | async) === true"></ui-release-alert>
<router-outlet></router-outlet>
